export default {
    loaded: "app.loaded",
    user: "app.user",
    cashback: "app.cashback",
    cashback_redeem: "app.cashback.redeem",
    cashapp: {
        initialized: "app.cashapp.initialized",
        reset: "app.cashapp.reset",
        request: "app.cashapp.request",
        confirmed: "app.cashapp.confirmed"
    },
    chime_recipient: "app.chime.recipient",
    chime_order: "app.chime.order",
    chime_reset: "app.chime.reset",
    cashapp_recipient: "app.cashapp.recipient",
    cashapp_order: "app.cashapp.order",
    cashapp_cashout: "app.cashapp.cashout",
    paypal_links: "app.paypal.links",
    paypal_order: "app.paypal.order",
    payou_order: "app.payou.order",
    cashapp_merchant_order: "app.cashapp_merchant.order",
    transaction: "app.transaction",
    modal_tx: "app.modal.transaction",
    modal_alert: "app.modal.alert",
    modal_qr: "app.modal.qr",
    bitcoin_profit: "app.bitcoin.profit",
    bitcoin_cashout: "app.bitcoin.cashout",
    bitcoin_cashout_approved: "app.bitcoin.cashout.approved",
    balance: "app.balance",
    tasks: "app.tasks",
    tasks_toggle: "app.tasks.toggle",
    toggleButton: "app.toggle.button",
    verification: "app.verification",
    square_order: "app.square.order",
    modal_halloween: "app.modal.halloween",
    modal_halloween_data: "app.modal.halloween.data",
    halloween_gifts: "halloween.gifts"
}